// Language Conversion Map
const languageConverter = {
  "zh-CN": "zh-Hans", 
  "jv": "jw", 
  "nn": "no", 
  "pt-PT": "pt",
  "pt-pt": "pt",
  "pt-br": "pt-BR",
  "zh-cn": "zh",
  "ja-jp": "ja",
  "ko-kr": "ko",
  "fr-fr": "fr",
  "it-it": "it",
  "de-de": "de",
  "es-es": "es",
  "sv-se": "sv",
  "ar-ae": "ar",
  "nl-nl": "nl",
  "nl-be": "nl",
  "he-il": "he",
  "pl-pl": "pl"
};

const newRedirectionArray = [
  "/de-de", "/pl-de", "/fr-de", "/it-de", "/it-it", "/de-it", "/fr-it", "/es-it", "/en-gb", "/pl-gb", "/fr-gb", "/de-gb", "/es-gb", "/en-au", "/zh-au", "/it-au", "/fr-au", "/en-ca", "/fr-ca", "/zh-ca", "/it-ca", "/de-ca",
  "/es-mx", "/en-mx", "/fr-mx", "/de-mx", "/fr-fr", "/es-fr", "/de-fr", "/pt-fr", "/ja-jp", "/zh-jp", "/ko-jp", "/es-es", "/fr-es", "/de-es", "/pt-es", "/en-pt", "/da-dk", "/el-gr", "/el-au", "/el-de", "/el-it", "/nn-no"
];

const domain404 = ["/en-de", "/en-it", "/de-au", "/pt-br-mx", "/en-fr", "/en-jp", "/pt-br-jp",  "/em-es", "/en-es"];

const autoRedirectedSubfolders = ["pt-pt", "nl-nl", "nl-be", "he-il", "pl-pl"];

// Get Current Language & URL Path
Localize.on("initialize", async function () {
  const sourceLang = Localize.getSourceLanguage();
  let curLang = Localize.getLanguage();
  let urlLang = window.location.pathname.split('/')[1] || curLang;
  const currentSubfolder = urlLang;
  let isCustomTransation = false;

  console.log("Source Language:", sourceLang);
  console.log("Current Language:", curLang);
  console.log("URL Language:", urlLang);

  if (!window.sessionStorage.getItem('load-language-converter') && languageConverter[urlLang]) {  
    console.log('Ifff');
   urlLang = languageConverter[urlLang]; 
   window.sessionStorage.setItem('load-language-converter',true);
    isCustomTransation = true;
  }else{
    console.log('else');
    urlLang = (curLang !== "source" ? curLang : "en");
  }
  
  if (curLang === "source") curLang = "en";

  console.log("curLang >> ",curLang, urlLang);

  let newLang = await determineNewLanguage(urlLang, curLang, sourceLang, isCustomTransation);

  console.log(">>",newLang,curLang);

  if (shouldRedirectLanguage(currentSubfolder, newLang)) {
    Localize.setLanguage(newLang);
    curLang = newLang;
    console.log(newLang,curLang);
    console.log(`Language changed from ${curLang} to ${newLang}`);
    setCookie("setLanguage", "false", 1);
  }
  buildLanguageDropdown(curLang);

});

/**
 * Determines the new language based on available Localize languages.
 */
async function determineNewLanguage(urlLang, curLang, sourceLang, isCustomTransation = false) {
  let newLang;

  if(isCustomTransation){
    return urlLang;
  }


  return new Promise((resolve) => {
    Localize.getAvailableLanguages((err, localizeLangs) => {
      if (err) {
        console.error(err);
        return resolve(sourceLang);
      }

      const targetLang = localizeLangs.find(lang => lang.code === urlLang);
      resolve(targetLang ? targetLang.code : sourceLang);
    });
  });
}

/**
 * Checks if the language should be changed.
 */
function shouldRedirectLanguage(currentSubfolder, newLang) {
  //UPDATED: Random redirect disabled
  // return getCookie("setLanguage") !== "false" || autoRedirectedSubfolders.includes(currentSubfolder);
   return autoRedirectedSubfolders.includes(currentSubfolder);
}

/**
 * Builds the language dropdown.
 */
function buildLanguageDropdown(curLang) {
  Localize.getAvailableLanguages((error, languageArray) => {
    if (error) return console.error(error);

    const languageDropdown = document.querySelector(".combo_box_wrapper");
    const customCountryCodes = languageDropdown.dataset.customCountryCodes.split(',');
    const selectedLanguage = languageArray.find(lang => lang.code === curLang);
    
    let languageHTML = `
      <div class="select-wrapper">
        <p class="combo-box__title heading h6">Select a language</p>
        <combo-box initial-focus-selector="[aria-selected='true']" id="custom-language-combo-box" role="combobox" aria-expanded="false" class="combo-box"  translate="no">
          <header class="combo-box__header">
            <p class="combo-box__title heading h6">Select a language</p>
            <button type="button" class="combo-box__close-button" data-action="close">
              <svg width="14" height="14" class="icon icon--close" viewBox="0 0 14 14">
                <path d="M13 13L1 1M13 1L1 13" stroke="currentColor" stroke-width="2"></path>
              </svg>
            </button>
          </header>
          <div class="combo-box__option-list" role="listbox">
            ${generateLanguageOptions(customCountryCodes, languageArray, curLang)}
          </div>
          ${generateLanguageSelectOptions(languageArray, curLang)}
        </combo-box>
        <button type="button" is="toggle-button" class="select" aria-expanded="false" aria-haspopup="listbox" aria-controls="custom-language-combo-box" aria-label="Select a language">
          <span id="custom-language-value">${selectedLanguage.name}</span>
          <svg width="12" height="8" class="icon icon--chevron" viewBox="0 0 12 8">
            <path fill="none" d="M1 1l5 5 5-5" stroke="currentColor" stroke-width="2"></path>
          </svg>
        </button>
      </div>`;

    languageDropdown.innerHTML = languageHTML;
    addLanguageSelectionEvents();
  });
}

/**
 * Generates language options HTML.
 */
function generateLanguageOptions(customCountryCodes, languageArray, curLang) {
  let options = "";

  customCountryCodes.forEach(code => {
    const language = languageArray.find(lang => lang.code === code);
    if (language) options += createLanguageButton(language, curLang);
  });

  languageArray.forEach(lang => {
    if (!customCountryCodes.includes(lang.code)) options += createLanguageButton(lang, curLang);
  });

  return options;
}

function generateLanguageSelectOptions(languageArray, curLang){
  let selectOptions = languageArray.map(language => {
    return `<option data-value="${ (language.code).toLowerCase() }" value="${ language.name }" ${ curLang === language.code ? "selected" : ""} >${ language.name }</option>`
  });
  return `<select class="visually-hidden" name="option-location" form="" data-bind-value="custom-language-value" aria-label="country-name">
            ${selectOptions.join('')}
          </select>`;
}

/**
 * Creates individual language button HTML.
 */
function createLanguageButton(language, curLang) {
  return `<button type="button" role="option" lang="${language.code}" 
            class="js-language-option combo-box__option-item" 
            value="${ language.name }"
            data-value="${language.code}" aria-selected="${curLang === language.code}">
              <span>${language.name}</span>
          </button>`;
}

/**
 * Adds event listeners to language options.
 */
function addLanguageSelectionEvents() {
  document.querySelectorAll('.js-language-option').forEach(option => {
    option.addEventListener('click', () => {
      document.querySelectorAll('.js-language-option').forEach(opt => opt.removeAttribute('aria-current'));
      option.setAttribute('aria-current', 'true');
    });
  });
}

// Shopify Localization Initialization
Localize.initialize({
  key: 'ZDyCgEFHMXEfn',
  rememberLanguage: true,
  saveNewPhrasesFromSource: true,
  disableWidget: true
});

/**
 * Returns market-specific URL for redirection.
 */
function getMarketURL(marketISOCode, languageCode) {
  const marketMapping = {
    cn: "zh-cn",
    jp: "ja-jp",
    kr: "ko-kr",
    fr: "fr-fr",
    it: "it-it",
    de: "de-de",
    es: "es-es",
    br: "pt-br",
    se: "sv-se",
    ae: "ar-ae",
    pt: "pt-pt",
    nl: "nl-nl",
    be: "nl-be",
    il: "he-il",
    pl: "pl-pl"
  };

  let languageDomain = `${languageCode}-${marketISOCode}`;

  if(languageDomain == "no-no"){
    return "nn-no"
  }
  
  if (newRedirectionArray.includes(`/${languageDomain}`)) {
    return `${languageCode}-${marketISOCode}` || marketMapping[marketISOCode];
  } else {
    sessionStorage.setItem("theme:new-page-domain", marketMapping[marketISOCode] || `en-${marketISOCode}`);
    return marketMapping[marketISOCode] || `en-${marketISOCode}`;
  }
  
}

/**
 * Handles language and market selection changes.
 */
function handleExperienceChange() {
  const marketISOCode = document.querySelector("#custom-currency-combo-box").nativeSelect.selectedOptions[0].dataset.value;
  const languageCode = document.querySelector("#custom-language-combo-box").nativeSelect.selectedOptions[0].dataset.value;

  if(sessionStorage.getItem("theme:new-page-domain")) sessionStorage.removeItem("theme:new-page-domain");
  if(sessionStorage.getItem("theme:404-page-found")) sessionStorage.removeItem("theme:404-page-found");
  if(sessionStorage.getItem("theme:404-redirect")) sessionStorage.removeItem("theme:404-redirect");
  if(sessionStorage.getItem("theme:original-redirection")) sessionStorage.removeItem("theme:original-redirection");

  let marketUrl = `/${languageCode}-${marketISOCode}`;

  if(marketUrl == "/no-no") {
    marketUrl == "/nn-no"
  }

  const marketRedirectionUrls = {
    "/en-de": "/de-de",
    "/en-it": "/it-it",
    "/de-au": "/en-au",
    "/pt-br-mx": "/en-mx",
    "/en-fr": "/fr-fr",
    "/en-jp": "/ja-jp",
    "/pt-br-jp": "/ja-jp",
    "/em-es": "/es-es",
    "/en-es": "/es-es"
  }
  
  if(marketRedirectionUrls[marketUrl]) {
    sessionStorage.setItem("theme:404-page-found", "true");
    sessionStorage.setItem("theme:new-page-domain", marketRedirectionUrls[marketUrl].replace('/',""));
  }

  if(!newRedirectionArray.includes(marketUrl)) {
    sessionStorage.setItem("theme:original-redirection", "true");
  }

  console.log(languageCode, marketISOCode);
  Localize.setLanguage(languageCode);
  
  setCookie('setLanguage', 'false', 1);

  let newLanguageDomain = getMarketURL(marketISOCode, languageCode);

  let urlToUpdate = window.location.href;
  let updatedUrl = insertLocale(urlToUpdate, marketISOCode == "us" ? null : newLanguageDomain);
  window.location.href = updatedUrl;
}

function insertLocale(url, locale) {
  try {
    let removeDomain = sessionStorage.getItem('languageToRemove');
    if (removeDomain) {
      url = url.replace(`${removeDomain}`, '');
    }
    let u = new URL(url);
    u.pathname = locale != null ? `/${locale}${u.pathname}` : `${u.pathname}`;
    return u.toString();
  } catch (e) {
    console.error("Invalid URL:", e);
    return `${window.location.origin}/${locale}`;
  }
}

// Handle Experience Change
document.querySelector(".js-change-experience").addEventListener("click", handleExperienceChange);


// Auto-click language options based on URL
const langMap = { "/nl-": "nl", "/he-": "he", "/pl-": "pl", "/pt-": "pt" };

for (const [key, value] of Object.entries(langMap)) {
  if (window.location.href.includes(key)) {
    setTimeout(() => {
      document.querySelector(`.js-language-option[data-value="${value}"]`)?.click();
    }, 1000);
    break;
  }
}

let currentUrl = window.location.pathname.split('/');

if(currentUrl[1] && currentUrl[1].includes('-')) {
  sessionStorage.setItem("languageToRemove", `/${currentUrl[1]}`);
}
else {
  sessionStorage.setItem("languageToRemove", '/');
}

if(currentUrl[1] && currentUrl[1].includes('-') && newRedirectionArray.includes(`/${currentUrl[1]}`) && sessionStorage.getItem("theme:404-page-found") != "true" && sessionStorage.getItem("theme:original-redirection") != "true"){
  let languageCountryPart = currentUrl[1].split('-');
  if(languageCountryPart[0] == "nn" && currentUrl[1] == "nn-no") {
    languageCountryPart[0] = "no";
  }
  if(languageCountryPart[0]){
    if(sessionStorage.getItem("theme:404-redirect")) {
      Localize.setLanguage(sessionStorage.getItem("theme:404-redirect"));
    }
    else {
      Localize.setLanguage(languageCountryPart[0]);
    }
  }
}
